import { useEffect } from 'react'
import { Provider } from 'react-redux'
import store, { persistor } from '@/redux/store'
import { PersistGate } from 'redux-persist/integration/react'

import Body from '@/Body'
import loadable from '@/utils/loadable'
import { ELO } from '@/utils/loadableHelpers'
import ErrorBoundary from '@/components/micro/ErrorBoundary'

const Maintenance = loadable(() => import('@/components/micro/Maintenance'), ELO)
const CheckNetwork = loadable(() => import('@/components/micro/CheckNetwork'), ELO)

// Lib Styles
import 'antd/dist/reset.css'

// App Styles
import '@/styles/vars.css'
import '@/styles/base.scss'

const loadNonCriticalCSS = () => {
	import('@/styles/main.scss')
}

const Application = () => {
	useEffect(() => {
		loadNonCriticalCSS()
	}, [])

	return (
		<ErrorBoundary>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<Body />
				</PersistGate>

				<CheckNetwork />
				<Maintenance />
			</Provider>
		</ErrorBoundary>
	)
}

export default Application
